/* eslint-disable @typescript-eslint/no-unsafe-assignment,import/no-cycle */
import useCheckout from 'components/ui/organisms/monarch/rules/checkout/useCheckout';
import useGeoPricing from 'components/ui/organisms/monarch/rules/geoPricing/useGeoPricing';
import useMultiCart from 'components/ui/organisms/monarch/rules/multiCart/useMultiCart';
import useValueReinforcement from 'components/ui/organisms/monarch/rules/valueReinforcement/useValueReinforcement';
import { MonarchTestHook } from '../types';
import useCheckoutExampleTest from './CheckoutExampleTest/useCheckoutExampleTest';

// Map of experiment rules
export const ruleMap: Record<string, MonarchTestHook> = {
  useValueReinforcement,
  useDegreeDetailRedesignTraffic: useCheckoutExampleTest,
  checkout: useCheckout,
  useMultiCart,
  useGeoPricing,
};
